module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.boxFormat !== 'component') ? _c('div', {
    staticClass: "kp-list-group-item clearfix"
  }, [_c('label', {
    staticClass: "kp-row box-title box-title__button",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.sidebarChangePanel('triggerbutton');
        _vm.canvasChangeView('triggerbutton')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('edit.sidebar.call_button_style')) + "\n    "), _vm._m(0)]), _vm._v(" "), _c('span')]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "btn is-circular has-icon"
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-079c9f3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/config/TriggerButton.vue
 ** module id = 752
 ** module chunks = 1
 **/